import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_FULL } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.BLOG)({
    component: RouteComponent,
});

function RouteComponent() {
    return <Outlet />;
}
